import { AnalyticsView } from './analytics.component';
import { withApollo } from 'react-apollo';

export const Analytics = withApollo(AnalyticsView);
